module.exports = "https://r.zoocdn.com/_next/static/images/Couch_illustration-b51b752eaf30959ce5662683dc8dd28b.svg";